import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";

import { AddEventScreen } from "../components";
import usePermission from "@/hooks/usePermission";

export const AddEvent = () => {
  const { showEvent } = usePermission();

  return (
    <ContentLayout title="Add Event" showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
            policyCheck={showEvent}
          >
            <AddEventScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
